import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TimerService {
  private timerInterval: ReturnType<typeof setInterval> | null = null;
  private timerStringSubject = new BehaviorSubject<string>('');
  private classStringSubject = new BehaviorSubject<string>('');
  private titleTimerSubject = new BehaviorSubject<string>('');

  timerString$ = this.timerStringSubject.asObservable();
  classString$ = this.classStringSubject.asObservable();
  titleTimer$ = this.titleTimerSubject.asObservable();

  startTimer(expirationDate: Date) {
    this.updateTimer(expirationDate);
    this.timerInterval = setInterval(() => {
      this.updateTimer(expirationDate);
    }, 1000);
  }

  updateTimer(expirationDate: Date) {
    const expirationDates = new Date(expirationDate);
    const localDate = new Date();
    const currentDate = new Date(localDate.getTime() + localDate.getTimezoneOffset() * 60000);
    const timeDifference = expirationDates.getTime() - currentDate.getTime();

    if (timeDifference <= 0) {
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.titleTimerSubject.next('Estado');
      this.timerStringSubject.next('Pago expirado');
      this.classStringSubject.next('red');
      return;
    }

    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    this.titleTimerSubject.next('Vence en');
    this.timerStringSubject.next(`<b>${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}</b> horas`);
  }

  private padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
}
